import "$styles/index.css"
import "$styles/syntax-highlighting.css"

import htmx from "htmx.org"
import StreetcarElements from "@heartml/streetcar-elements"
import "@heartml/streetcar-elements/src/htmx-extension.js"
window.htmx = htmx

import { Application } from "downflow"

import "@awesome.me/webawesome/dist/components/badge/badge.js"
import "@awesome.me/webawesome/dist/components/button/button.js"
import "@awesome.me/webawesome/dist/components/button-group/button-group.js"
import "@awesome.me/webawesome/dist/components/copy-button/copy-button.js"
import "@awesome.me/webawesome/dist/components/dialog/dialog.js"
import "@awesome.me/webawesome/dist/components/drawer/drawer.js"
import "@awesome.me/webawesome/dist/components/dropdown/dropdown.js"
import "@awesome.me/webawesome/dist/components/icon/icon.js"
import "@awesome.me/webawesome/dist/components/input/input.js"
import "@awesome.me/webawesome/dist/components/option/option.js"
import { registerIconLibrary } from "@awesome.me/webawesome"
import "@awesome.me/webawesome/dist/components/popover/popover.js"
import "@awesome.me/webawesome/dist/components/select/select.js"
import "@awesome.me/webawesome/dist/components/toast/toast.js"

import "./lib/retainedState.js"
import idleness from "./lib/idleness.js"
import { setAttributes } from "./lib/domHelpers.js"
import "./jude_prose_element.js"
import "./jude_widget_elements.js"

const configs = {} //{ timeout: 6000 };
const idle = new idleness(configs, true);

// TODO: this sorta isn't working, should replace with visibilitychange
document.addEventListener('idle', (event) => {
  if (!event.detail.idle) {
    //location.reload()
  }
  //document.querySelector("body > wa-toast").create(event.detail.idle ? 'IDLE' : 'ACTIVE')
});

window.addEventListener("focus", () => {
  // NOTE: this is just for testing on devices to see how the behavior works
  document.querySelector("body > wa-toast").create("Window focus")
});

// document.addEventListener("visibilitychange", () => {
//   if (!document.hidden) {
//     // NOTE: this is just for testing on devices to see how the behavior works
//     document.querySelector("body > wa-toast").create("Welcome back!")
//   }
// });

const application = Application.start()
application.context = {
  hidePopover(event) {
    event.currentTarget.closest("wa-popover").hide()
  },
  sections: {
    toggleRollup(event) {
      const btn = event.currentTarget
      const section = btn.closest("section")
      const sectionUuid = section.getAttribute("jude-uuid")
      section.toggleAttribute("jude-rolled-up")
      const isRolledUp = section.hasAttribute("jude-rolled-up")
      window.retainedState.getNamespace("jude.sections")[`${sectionUuid}.rolledUp`] = isRolledUp
      btn.querySelector("strong").textContent = isRolledUp ? "+" : "-"
    },
    addWidget(event) {
      const sectionUuid = event.currentTarget.getAttribute("jude-section-uuid")
      htmx.process(
        setAttributes(
          document.querySelector(`wa-popover[for=add-widgets-for-section-${sectionUuid}]`),
          {
            "hx-trigger": "load",
            "hx-get": "/widgets/add",
            "hx-vals": `{"section_uuid":"${sectionUuid}"}`,
          },
        ),
      )
    },
  },
}

class JUDEToolbarElement extends HTMLElement {
  static {
    customElements.define("jude-toolbar", this)
  }

  connectedCallback() {
    window.addEventListener("scroll", () => {
      this.classList.toggle("is-sticky", this.getBoundingClientRect().y < 10)
    })
  }
}

// Set up Phosphor icon Set
const phosphorIconResolver = {
  resolver: (name) => {
    const iconName = name.toLowerCase().replace(/_/g, "-")
    return `https://cdn.jsdelivr.net/npm/@phosphor-icons/core@2.1.1/assets/regular/${iconName}.svg`
  },
}

const phosphorDuotoneIconResolver = {
  resolver: (name) => {
    const iconName = name.toLowerCase().replace(/_/g, "-")
    return `https://cdn.jsdelivr.net/npm/@phosphor-icons/core@2.1.1/assets/duotone/${iconName}-duotone.svg`
  },
}

registerIconLibrary("phosphor", phosphorIconResolver)
registerIconLibrary("phosphor-duotone", phosphorDuotoneIconResolver)
registerIconLibrary("default", phosphorIconResolver)

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

sectionsState = window.retainedState.getNamespace("jude.sections")
document.querySelectorAll("section[jude-uuid]").forEach((section) => {
  sectionsState.retained(`${section.getAttribute("jude-uuid")}.rolledUp`, (isRolledUp) => {
    section.toggleAttribute("jude-rolled-up", isRolledUp)
    // TODO: this needs a way better selector
    section.querySelector(":scope > header > wa-button-group > wa-button > strong").textContent =
      isRolledUp ? "+" : "-"
  })
})
console.info("JUDE is loaded.")
